import { SelectionModel } from '@angular/cdk/collections';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatListOption } from '@angular/material/list';
import { MatSidenav } from '@angular/material/sidenav';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import _ from 'lodash';
import { Observable, Subject, lastValueFrom, takeUntil } from 'rxjs';
import { DropDownOptions, ExtendedMaterialSubGroup } from 'src/app/shared/models/app-models';
import { IItemToRequest, MyPurchaseForm, VendorTagging } from 'src/app/shared/models/app-models/MyPurchaseForm.model';
import SourcingStatus from 'src/app/data/constants/SourcingStatus.json';
import { StoreDropdowns } from 'src/app/shared/models/app-models/StoreDropdowns.model';
import { UserInformation } from 'src/app/shared/models/app-models/UserInformation.model';
import { Vendor } from 'src/app/shared/models/database-models';
import { addVendorTagging, clearTaggingStore, updateVendorTagging } from 'src/app/core/store/TaggedVendors.action';
import { addItemtoMyPurchase } from 'src/app/core/store/form.actions';
import { DecimalPipe } from '@angular/common';
import { doesNotMeetRfsCriteria } from 'src/app/modules/shared/utils/check-rfs-criteria';
import { RfsSourcingResponse } from 'src/app/shared/components/global-banner/dto/rfs-sourcing-response.model';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { FormTransformerPipe } from 'src/app/shared/pipes/form-transformer/form-transformer.pipe';
import { PermissionsService } from 'src/app/core/services/permissions/permission.service';

@Component({
  selector: 'app-tag-item-vendor',
  templateUrl: './tag-item-vendor.component.html',
  styleUrls: ['./tag-item-vendor.component.scss'],
  providers: [
    {
      provide: DecimalPipe,
    }
  ],
})
export class TagItemVendorComponent implements OnInit{
  @ViewChild('vendorSearch') vendorSearch!: MatSidenav;
  @Input() isReadOnly: boolean = false;

  @Input() currentRoute = ['Purchase Modes'];
  breadCrumbFlow:string[]=['Purchase Modes'];
  currentPageString: string = 'Tag item vendor';
  activePage: string = 'Tag item vendor';
  mpNumber: string = '';

  @ViewChild('availableList', {static: true}) private availableList: any; 
  @ViewChild('selectedList', {static: true}) private selectedList: any; 

  //Material Sub Group
  MatSGpdropdown: DropDownOptions[] | ExtendedMaterialSubGroup[] = [];
  form!: MyPurchaseForm;
  choices = ['Yes', 'No'];
  vendorType: string = 'normal';
  vendorActionType: string = 'itemVendor';
  addVendorSidenav: boolean = false;
  isAllExistingVendorsChecked: boolean = false;
  isAllTaggedVendorsChecked: boolean = false;
  isEditable : boolean = true;
  destroy$: Subject<boolean> = new Subject<boolean>();
  vendorDataSource = new MatTableDataSource<Vendor>([]);
  itemList: IItemToRequest[] = [];
  deactivatedItems: IItemToRequest[] = [];
  vendorColumns = [
    {
      columnDef: 'Name',
      header: 'Vendor name',
      cell: (element: Vendor) => `${element.Name}`,
    }
  ];
  vendorForm!: Vendor[];
  vendorDisplayedColumns = [
    'vSelect',
    ...this.vendorColumns.map((c) => c.columnDef),
  ];
  pageSizeOptions = [5, 10, 20, 50];
  purchaseType: string = '';
  vendorEdited!: Vendor;
  vendorTaggingForm!: FormGroup;
  storeDropdowns?: StoreDropdowns;
  vendorTaggingList :any = [];
  rowSelection = new SelectionModel<Vendor>(true, []);
  itemDescriptionDropdown : any = [];
  sourcingStatus : any = SourcingStatus;
  listOfExistingVendors: any = [];
  listOfTaggedVendors: any = [];
  selectedLeftIds: number[] = [];
  selectedRightIds: number[] = [];
  mode: string = 'add';
  itemNo: number = 0;
  sourcingStatusId : any = 1;
  selectedItem = 0;
  selectedMaterialSubGroup = '';
  permissionData$:Observable<any>
  itemDetails = {
    ItemPrice : {
      Quantity : 0,
      UnitsPerQuantity : 0,
      UnitPrice : '',
      Currency : '',
      UnitOfMeasurement : '',
      EstimatedUnitPrice : ''
    },
    ItemDetails : {
      PartModelNumber : '',
      isCOTS : '',
      ItemDescription : '',
      BrandOEMName : '',
      MaterialGroupId : '',
      MaterialSubGroupId : '',
      CriticalityId : '',
      WorkmanshipId :''
    }
  };
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _fb: FormBuilder,
    private permissionService:PermissionsService,
    private backendService: BackendApiService,
    private transformer: FormTransformerPipe,
    private decimalPipe: DecimalPipe,
    private store: Store<{
    form: MyPurchaseForm;
    tagging: VendorTagging;
    user: UserInformation;
    dp: StoreDropdowns;
  }>) {
    const previousPageName = sessionStorage.getItem('fromPage');
    if (previousPageName) {
      this.breadCrumbFlow = [previousPageName];
    } 
    this.permissionData$ = permissionService.getService().pipe(takeUntil(this.destroy$))
    this.mode = this.route.snapshot.params['itemNo'] ? 'edit' : 'add';
    if (this.mode === 'edit') {
      this.itemNo = this.route.snapshot.params['itemNo'];
    }
    this.mpNumber = this.route.snapshot.params['id'];
    this.purchaseType = this.route.snapshot.params['purchaseType'].split(
      ';'
    )[0] as string;

    this.setHeaderPath(this.purchaseType);
    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe((dp: StoreDropdowns) => {
        this.storeDropdowns = dp;
        this.MatSGpdropdown = dp.MaterialSubGroup;
      });
    this.store
      .select('form')
      .pipe(takeUntil(this.destroy$))
      .subscribe((form: MyPurchaseForm) => {
        this.form = form;
        if(form.documentStatusId != 15) this.isEditable = false;
        this.vendorForm = form.VendorsToSource;
        this.vendorForm.forEach((vendor:any) =>{
          let vendorObj = {
            "Name": vendor.Name,
            "VendorNumber": vendor.VendorNumber
          }
          let isPresent = this.isObjectPresent(vendor.VendorNumber);
          if(vendor.itemToTag && vendor.itemToTag == this.itemNo && !isPresent){
            this.listOfTaggedVendors.push(vendorObj)
          }
        })
        this.listOfExistingVendors = form.VendorsToSource.map(({ Name, VendorNumber }) => ({ Name, VendorNumber }));
        if(this.listOfTaggedVendors.length > 0 && this.sourcingStatusId == null){
          this.sourcingStatusId = 1;
        }
        this.listSourcingStatus();
        this.itemList = form.ItemList || [];
        this.vendorDataSource = new MatTableDataSource<Vendor>(
          structuredClone(
            this.vendorForm.filter((vendor) => !vendor.isDeleted).slice()
          )
        );
      });
      this.store
      .select('tagging')
      .pipe(takeUntil(this.destroy$))
      .subscribe((tagging: any) => {
        let vendorTaggingSet = new Set();
        this.vendorTaggingList = tagging.tags.filter((tag:any) => {
          const tagString = JSON.stringify(tag);
          if (vendorTaggingSet.has(tagString)) {
            return false;
          }
          vendorTaggingSet.add(tagString);
          return true;
        });
      });

      this.vendorTaggingForm = this._fb.group({
        itemSelected: [[Validators.required]],
        materialSubGroup: [[Validators.required]],
        isExistingVendorsChecked: [],
        isTaggedVendorsChecked: [],
        sourcingStatus: [this.sourcingStatusId,[Validators.required]]
      });
  }

  ngOnInit(): void {
    this.itemDescriptionMapping();
    if(this.mode == 'edit'){
      this.patchVendorTagData()
    }
  }

  isObjectPresent(vendorNumber:string) {
    let isVendorPresent = false;
    this.listOfTaggedVendors.forEach((vendor:any) =>{
      if(vendor.VendorNumber === vendorNumber){
        isVendorPresent = true;
      }
    })
    return isVendorPresent;
  }

  async checkIfRfs(form: MyPurchaseForm, storeDropdowns: StoreDropdowns) {
    if (doesNotMeetRfsCriteria(form)) return
    if (this.deactivatedItems.length > 0) return;
    console.log('returned')
    const resp: RfsSourcingResponse = await lastValueFrom(this.backendService.getSourcingOutcomes(form.documentNo!))
    if (resp.deactivatedItemList) {
      console.log('inside')
      let results = this.transformer.parseItemListData(resp.deactivatedItemList, storeDropdowns).map(x => ({
        ...x,
        isDeleted: true
      }))
      this.deactivatedItems = results
    }
  }
  
  onMaterialSubGroupChange(event: ExtendedMaterialSubGroup | null) {
    if (event != null) {
      let ItemToDisplay = this.itemList.find(
        (item) => item.AddItems.MaterialSubGroupId?.Code == event.Code
      );
    }
  }

  onSelectionItemDescription(event: any) {
    console.log("onSelectionItemDescription : ",event);
  }

  mapVendors(item:number){
    let vendorTag : any = [];
    let itemVendor = this.vendorTaggingList.filter((vendorItem:any) =>vendorItem.id == item)
    if(itemVendor.length > 0){
      for(let i=0; i< itemVendor[0].vendorNumber.length; i++){
        this.vendorForm.filter(vendorInfo =>{
          if(vendorInfo.VendorNumber == itemVendor[0].vendorNumber[i]){
            vendorTag.push({ Name : vendorInfo.Name, VendorNumber : vendorInfo.VendorNumber })
          }
        })
      }
    }
    return vendorTag;
  }

  mapSourcingStatus(item:number){
    let itemVendor = this.vendorTaggingList.filter((vendorItem:any) =>vendorItem.id == item);
    return itemVendor[0]?.status;
  }

  selectAllAvailable(){
    this.isAllExistingVendorsChecked ? this.availableList.selectAll() : this.availableList.deselectAll();
  }
  
  selectAllTagged(){
    this.isAllTaggedVendorsChecked ? this.selectedList.selectAll() : this.selectedList.deselectAll();
  }

  async patchVendorTagData(){   
      if (this.storeDropdowns) await this.checkIfRfs(this.form, this.storeDropdowns);
      if(this.deactivatedItems.length > 0){
        this.itemList = this.itemList.concat(this.deactivatedItems);
      }
      let editedItem = this.itemList.filter((items:any) => items.AddItems.itemId == this.itemNo);
      console.log("editedItem : ",editedItem);
      this.sourcingStatusId = this.mapSourcingStatus(editedItem[0]?.AddItems.PurchaseItemId ?? 0);
      this.selectedItem = editedItem[0]?.AddItems?.itemId ?? 0
      this.selectedMaterialSubGroup = editedItem[0]?.AddItems.MaterialSubGroupId?.Code ?? "";
      let mappedVendors = this.vendorForm.map(({ Name, VendorNumber }) => ({ Name, VendorNumber }));
      let listOfMappedVendors = this.mapVendors(editedItem[0]?.AddItems.PurchaseItemId ?? 0);

      //appending tagging list
      this.listOfExistingVendors = this.filterVendorList(mappedVendors);
      this.listOfTaggedVendors = this.filterVendorList(listOfMappedVendors);

      this.listSourcingStatus();

      let estmitedAmount =
        (editedItem[0]?.ItemPrice.Quantity * editedItem[0]?.ItemPrice.UnitPrice) /
        editedItem[0]?.ItemPrice.UnitsPerQuantity;

      this.itemDetails.ItemPrice.UnitPrice = this.decimalPipe.transform(editedItem[0]?.ItemPrice.UnitPrice, '1.2') ?? '-';
      this.itemDetails.ItemPrice.Quantity = editedItem[0]?.ItemPrice.Quantity ?? '-';
      this.itemDetails.ItemPrice.UnitsPerQuantity = editedItem[0]?.ItemPrice.UnitsPerQuantity ?? '-';
      this.itemDetails.ItemPrice.Currency = editedItem[0]?.ItemPrice.Currency.value ?? '-';
      this.itemDetails.ItemPrice.UnitOfMeasurement = editedItem[0]?.ItemPrice.UnitOfMeasurement.value ?? '-';
      this.itemDetails.ItemPrice.EstimatedUnitPrice = this.decimalPipe.transform(estmitedAmount, '1.2') ?? '-';

      this.itemDetails.ItemDetails.PartModelNumber = editedItem[0]?.AddItems.PartModelNumber != "" ? editedItem[0]?.AddItems.PartModelNumber ?? '-' : '-';
      this.itemDetails.ItemDetails.isCOTS = editedItem[0]?.AddItems.isCOTS?.value ?? '-';
      this.itemDetails.ItemDetails.ItemDescription = editedItem[0]?.AddItems.ItemDescription != "" ? editedItem[0]?.AddItems.ItemDescription ?? '-' : '-';
      this.itemDetails.ItemDetails.BrandOEMName = editedItem[0]?.AddItems.BrandOEMName?.value ?? '-';
      this.itemDetails.ItemDetails.MaterialGroupId = editedItem[0]?.AddItems.MaterialGroupId?.Name ?? '-'
      this.itemDetails.ItemDetails.MaterialSubGroupId = editedItem[0]?.AddItems.MaterialSubGroupId?.Name ?? '-'
      this.itemDetails.ItemDetails.CriticalityId = editedItem[0]?.AddItems.CriticalityId?.value ?? '-';
      this.itemDetails.ItemDetails.WorkmanshipId = editedItem[0]?.AddItems.WorkmanshipId?.value ?? '-';

      console.log("this.itemDetails : ",this.itemDetails);
  }

  itemDescriptionMapping(){
    this.itemList.forEach(item =>{
      console.log("item : ",item);
      this.itemDescriptionDropdown.push({
        id : item.AddItems.itemId,
        value : 'Item no.' + item.AddItems.displayItemNumber + ' - ' + item.AddItems.ItemDescription
      })
    })
    console.log("this.itemDescriptionDropdown : ",this.itemDescriptionDropdown);
  }

  filterVendorList(vendorList : any){
    const uniqueVendorsList = new Set(vendorList.map((item:any) => JSON.stringify(item)));
    let filteredVendors = Array.from(uniqueVendorsList).map((item:any) => JSON.parse(item));
    return filteredVendors;
  }

  onLeftSelection(options: MatListOption[]) {
    this.selectedLeftIds = [];
    options.map(o => {
      this.selectedLeftIds.push(o.value);

    });
    // console.log("selectedLeftIds: ", this.selectedLeftIds);
  }

  onRightSelection(options: MatListOption[])  {
    console.log("onRightSelection : ",options);
    this.selectedRightIds = [];
    options.map(o => {
      this.selectedRightIds.push(o.value);

    });
    // console.log("selectedRightIds: ", this.selectedRightIds);
  }

  transferRight(ids: number[] = this.selectedLeftIds) {
    console.log("transferRight ids: ", ids);
    //Find elements by id in available list
    const selectedElements =  _.filter(this.listOfExistingVendors, (v:any) => _.includes(ids, v.VendorNumber));
    this.listOfTaggedVendors = [...this.listOfTaggedVendors, ...selectedElements];
    this.listOfTaggedVendors = this.filterVendorList(this.listOfTaggedVendors)
    if(this.listOfTaggedVendors.length > 0 && this.sourcingStatusId == null){
      this.sourcingStatusId = 1;
    }
    this.listSourcingStatus();
  }

  transfeLeft(ids: number[] = this.selectedRightIds) {
    console.log("transfeLeft ids: ", ids);
    //Find elements by id in available list
    const selectedElements =  _.filter(this.listOfTaggedVendors, (v:any) => _.includes(ids, v.VendorNumber));
    this.listOfTaggedVendors = _.remove(this.listOfTaggedVendors, (tagVendor:any) => {
        return  selectedElements.findIndex(elm => tagVendor.VendorNumber === elm.VendorNumber) < 0;
    });
    if(this.listOfTaggedVendors.length == 0){
      this.sourcingStatusId = null;
    }
    this.listSourcingStatus();
  }

  transferAllToRight() {
    if(this.isAllExistingVendorsChecked){
      let vendorsToTag = this.listOfExistingVendors.map(function(key :any) {
        return key.VendorNumber;
      });
      const selectedElements =  _.filter(this.listOfExistingVendors, (v:any) => _.includes(vendorsToTag, v.VendorNumber));
      this.listOfTaggedVendors = [...this.listOfTaggedVendors, ...selectedElements];
      this.listOfTaggedVendors = this.filterVendorList(this.listOfTaggedVendors);
    }
    if(this.listOfTaggedVendors.length > 0 && this.sourcingStatusId == null){
      this.sourcingStatusId = 1;
    }
    this.listSourcingStatus();
    this.clearCheckBox();
  }

  transferAllToLeft() {
    if(this.isAllTaggedVendorsChecked){
      let vendorsToUntag = this.listOfExistingVendors.map(function(key :any) {
        return key.VendorNumber;
      });
      const selectedElements =  _.filter(this.listOfTaggedVendors, (v:any) => _.includes(vendorsToUntag, v.VendorNumber));
      this.listOfTaggedVendors = _.remove(this.listOfTaggedVendors, (tagVendor:any) => {
        return  selectedElements.findIndex(elm => tagVendor.VendorNumber === elm.VendorNumber) < 0;
      });
    }
    if(this.listOfTaggedVendors.length == 0){
      this.sourcingStatusId = null;
    }
    this.listSourcingStatus();
    this.clearCheckBox();
  }

  listSourcingStatus(){
    this.sourcingStatus = this.sourcingStatus.map((item:any) => {
      const disabled = this.listOfTaggedVendors.length > 0 ? item.SourcingStatusId !== 1 : item.SourcingStatusId === 1;
      return { ...item, disabled: disabled };
    });
  }
  clearCheckBox(){
    this.isAllTaggedVendorsChecked =false;
    this.isAllExistingVendorsChecked = false;
  }
  get mappedVendors() {
    return _.differenceWith(this.listOfExistingVendors, this.listOfTaggedVendors, _.isEqual);
  }

  returnToTagging = (args: any): void => {
    this.router.navigate([
      '/purchase/',
      this.purchaseType,
      this.mpNumber,
      { tagged : true },
    ]);
  };

  setHeaderPath(purchaseType : string){
    switch (purchaseType) {
      case 'rfq':
        this.currentRoute.push('Request For Quotation');
        this.breadCrumbFlow.push('Request For Quotation');
        break;
      case 'tender':
        this.currentRoute.push('Tender');
        this.breadCrumbFlow.push('Tender');
        break;
      case 'corporatecard':
        this.currentRoute.push('Corporate Credit Card');
        this.breadCrumbFlow.push('Corporate Credit Card');
        break;
      case 'dc':
        this.currentRoute.push('Direct Contracting');
        this.breadCrumbFlow.push('Direct Contracting');
        break;
      case 'permissiblecoveringpurchaseorder':
        this.currentRoute.push('Permissible Reasons');
        this.breadCrumbFlow.push('Permissible Reasons');
        break;
    }
  }
  async buttonHandler($event: any) {
    switch ($event.actionType as string) {
      case 'tag-item-vendor':
        this.updateAndReturnToTagging()
        break
      default:
        // do nothing
        break;
    }
  }

  updateAndReturnToTagging = (): void => {
    console.log("******************* update the data from here *******************");
    console.log("this.vendorTagging form ",this.vendorTaggingForm.value);

    console.log("this.listOfExistingVendors : ",this.listOfExistingVendors)
    console.log("this.listOfTaggedVendors : ",this.listOfTaggedVendors)
    let formVlaues = this.vendorTaggingForm.value;
    let selectedItem = this.itemList.filter((items:any) => items.AddItems.itemId == formVlaues.itemSelected);
    console.log(" selectedItem ",selectedItem[0])

    console.log("vendorTaggingList ",this.vendorTaggingList)

    const replacementObject = {
      id: selectedItem[0]?.AddItems.PurchaseItemId ?? 0,
      vendorNumber:  this.listOfTaggedVendors ? this.listOfTaggedVendors.map(({ VendorNumber } :any) => VendorNumber) : [],
      status: formVlaues.sourcingStatus
    };
    console.log("replacementObject : ",replacementObject);
    let modifiedTaggedVendors = this.vendorTaggingList.map((obj:any) => (obj.id == replacementObject.id && (obj.vendorNumber != replacementObject.vendorNumber || obj.status != replacementObject.status) ? replacementObject : obj));
    console.log("modifiedTaggedVendors ",modifiedTaggedVendors)
    this.store.dispatch(
      updateVendorTagging({
        tagging : modifiedTaggedVendors
      })
    );

    this.router.navigate([
      '/purchase/',
      this.purchaseType,
      this.mpNumber,
      { tagged: true },
    ]);
  }

  taggedVendorsIds(tags:any){
    let vendorsArray = tags.map(function(key :any) {
        return key.VendorNumber;
      });
    return vendorsArray;
  }

  editVendorOpen(row: Vendor) {
    this.vendorType = 'edit';
    this.vendorEdited = row;
    this.vendorSearch.open();
  }

  normalVendorOpen() {
    this.addVendorSidenav = true;
    this.vendorType = 'normal';
    this.vendorSearch.open();
  }

  aslVendorOpen() {
    this.vendorType = 'asl';
    this.vendorSearch.open();
  }

  masterVToggle() {
    if (this.isAllVSelected()) {
      this.rowSelection.clear();
    } else {
      this.vendorDataSource.data.forEach((row) =>
        this.rowSelection.select(row)
      );
    }
  } //vendors

  // function to check if all checkboxes are checked
  isAllVSelected() {
    const numSelected = this.rowSelection.selected.length;
    const numRows = this.vendorDataSource.data.length;
    return numSelected === numRows;
  }

  isVselected() {
    if (this.rowSelection.selected.length !== 0) return true;
    return false;
  }
  // checkbox toggling
  onCheckboxChange($event: any, row: any) {
    $event ? this.rowSelection.toggle(row) : null;
  }

}
